import API_CONFIG from './apis';
import { GetMsgResCode } from '@/utils/constants';

// live chat sdk 白名单
// 不传 chat-access-token 和 token-suffix
export const noneAccessTokenUrlList = [
  API_CONFIG.getStaticResources.url,
  '/emergency/template',
];

export const whiteListCodes = [
  GetMsgResCode.CANCEL_ORDER_FAILED,
  GetMsgResCode.ARTICLE_IS_DELETED,
  GetMsgResCode.MULTI_TERMINAL_CONFLICT,
]; // 用于直接判断进入白名单处理逻辑的

const WHITE_LIST = [
  API_CONFIG.getOrderList.url,
  API_CONFIG.getUserInfo.url,
  API_CONFIG.postHeartbeat.url,
  API_CONFIG.getReturnList.url,
  API_CONFIG.suggestion.url,
  API_CONFIG.getArticleContent.url,
  API_CONFIG.getChatHistory.url,
  API_CONFIG.uploadMessage.url,
  API_CONFIG.getNextHeadIntent.url,
  API_CONFIG.getUserEvents.url,
  API_CONFIG.reportUserEvents.url,
  API_CONFIG.getStaticResources.url,
  'upload_part',
  'report_user_read_msg_offset',
  API_CONFIG.refreshIntents.url,
  API_CONFIG.getLiveAgentConnectionInfo.url,
  API_CONFIG.getExperiment.url,
  API_CONFIG.submitProbingForm.url,
  API_CONFIG.joinedQueue.url,
  API_CONFIG.getUserSwitch.url,
  API_CONFIG.getLandingPagePredict.url,
  API_CONFIG.getComposedInitSession.url,
];

function isInWhiteList(url, rescode) {
  if (typeof url !== 'string' || url.length === 0) {
    return false;
  }

  for (let i = 0, len = WHITE_LIST.length; i < len; i++) {
    if (url.match(WHITE_LIST[i])) {
      return true;
    }
  }

  if (whiteListCodes.includes(rescode)) {
    return true;
  }

  return false;
}

export default isInWhiteList;
